import React from 'react';
import TableAddEdit from './TableAddEdit.js';
import Popup from './Popup.js';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import db from './db';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import OrderDetailTable from './OrderDetailTable'
import SearchPopupButton from "./SearchPopupButton"
import FacilityPopup from "./FacilityPopup.js"
var tableColumnRender = require("./TableColumnRender.js")
//import TabList from 'react-tabs/lib/components/TabList.js';
//import { Tab, TabPanel } from 'react-tabs';
var tae = require("./TableAddEdit.js");

// OrderHeaderTable component
export default class OrderHeaderTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.orderHeaderTableRef = React.createRef();
        let cols=[];
        try{ 
            cols.push({ key: 'facility_id', title:"Facility Id", noquery:true, doNotDisplayInTable:true,width:5 });
            cols.push({ key: 'source_order_id', title:"Source Order Id(wix..)",width:5 });
            cols.push({ key: 'display_name', title:"Name",width:50});
            cols.push({ key: 'description', title:"Description",width:5 });
            cols.push({ key: 'note', title:"note", render: tableColumnRender.renderMultiLineText, memo:true,editClassName:"line-note-4",width:5});
            cols.push({ key:"order_purpose",title:"Purpose", doNotDisplayInTable:true , options:this.props.orderPurposeList,width:5})
            cols.push({ key:"order_purpose_label",title:"Purpose", noedit:true,width:5,editClassName:"hidden"})
            cols.push({ key: 'last_updated_time', title:"Last Updated" ,  noedit:true,width:5,editClassName:"hidden"});
            cols.push({ key: 'id', title:"id", noquery:true, doNotDisplayInTable:true, noedit:true,width:5 ,editClassName:"hidden"});
            cols.push({ key: 'order_type', title:"Order Type", noquery:true, doNotDisplayInTable:true, noedit:true,width:5 ,editClassName:"hidden"});
            cols.push({ key: 'order_id', title:"Order Id", noquery:true, doNotDisplayInTable:true, noedit:true,width:5,editClassName:"hidden" });
        } catch (ex){}        
        this.state={
            postObj:[],
            edited:false,
            selectedObject:false,
            orderAddress:false,
            columns:cols,
            facilityPopupVisible:false,
            contacts:[]
        };

    }
    componentDidUpdate(prevProps) {
        if(document.getElementById("inputTableAddEditdisplay_name")){
            document.getElementById("inputTableAddEditdisplay_name").readOnly=true;
            document.getElementById("inputTableAddEditfacility_id").readOnly=true;
        }
    }
    componentDidMount(prevProps) {
        setTimeout(() => { 
                this.queryData();
        }, 500);         
    }
    queryData(){
        this.orderHeaderTableRef.current.queryData();
    }
    // render
    render() {
        let qry=`api/get/orderHeader?order_type=${this.props.orderType}&`;  
        let update="api/updateOrderHeader";
        return (true)?(
            <div className='relative-div'>
                <h2>{this.props.title}</h2>
                <div className="align-right">
                    <a target="new" href="https://app.hubspot.com/">Hubspot</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a target="new" href="https://apps.goshippo.com/">shippo</a>
                </div>
                <TableAddEdit
                    queryURL={qry}
                    updateURL={update}
                    columns={this.state.columns}
                    securityObject={this.props.securityObject}
                    tableHeight="70vh"
                    key="tableAddEditTableAddEdit"
                    showEditScreen={this.showEditScreen.bind(this)}
                    ref={this.orderHeaderTableRef}
                    afterQuery={this.props.afterQuery}
                >
                </TableAddEdit>
                <Popup trigger={this.state.selectedObject} afterClose={this.afterClosePopup.bind(this)}>
                        <h2>{this.props.title}</h2>
                        <div className="align-right">
                            <button onClick={() => this.closePopup()}>
                                x
                            </button>  
                        </div>
                        <Tabs>
                            <TabList>
                                <Tab>Header</Tab>
                                <Tab disabled={this.state.selectedObject.id===-1 ||this.state.edited}>Detail</Tab>
                            </TabList>
                            <TabPanel>
                                <div style={{ height:"80vh" }}>
                                    <button disabled={!this.state.edited} onClick={() => this.saveChanges()}>Save</button>
                                    <button disabled={!this.state.edited} onClick={() => this.closePopup()}>Cancel</button>                    
                                    <br />
                                    <SearchPopupButton
                                            securityObject={this.props.securityObject}
                                            buttonLabel='Select Facility'
                                            title='Select Facility for this Order (if facility is not found you may need to close window and "Create Facility from HubSpot Company")'
                                            query={this.props.securityObject.httpServer + "api/get/facilitySearch?"}
                                            columns={[
                                                    //{ key: 'id', title:"Facility id", width :20 }
                                                    { key: 'display_name', title:"name", width :40 }
                                                    ,{ key: 'display_contact_name', title:"contact", width :40 }
                                                    ,{ key: 'source', title:"source", width :40 }
                                                    ,{ key: 'display_address', title:"address", width :40 }
                                                    ,{ key: 'display_city', title:"city", width :40 }
                                                    ,{ key: 'display_state', title:"state", width :40 }
                                                    ,{ key: 'display_zip', title:"zip", width :40 }
                                                    ]}
                                            onClick={this.selectFacility.bind(this)}
                                            onDislpayPopup={()=>this.hideContacts()}
                                            onClosePopup={()=>this.showContacts()}
                                        ></SearchPopupButton>
                                        <SearchPopupButton
                                            securityObject={this.props.securityObject}
                                            buttonLabel="Create Facility from HubSpot Company"
                                            query={this.props.securityObject.httpServer + "api/get/hubSpotCompany?"}
                                            columns={[
                                                    { key: 'hubspot_object_id', title:"Hubspot Object Id", width :20, noquery:true }
                                                    ,{ key: 'name', title:"HubSpot Name", width :40, noquery:true }
                                                    ,{ key: 'address', title:"address", width:40, noquery:true}
                                                    ,{ key: 'city', title:"city", width :40, noquery:true }
                                                    ,{ key: 'facility_name', title:"Facility Name", width :40, noquery:true }
                                                    ,{ key:'facility_id', title:"Facility_id", width:10, noquery:true}
                                                    ,{ key:'search_column', title:"search", width:10}
                                                    ]}
                                            onClick={this.createFacilityHubSpotCompany.bind(this)}
                                            onDislpayPopup={()=>this.hideContacts()}
                                            onClosePopup={()=>this.showContacts()}
                                        ></SearchPopupButton>
                                    
                                    <button onClick={()=>this.setState({facilityPopupVisible:true})}>View Facility</button>
                                    <button onClick={()=>{
                                            let postObj=this.state.postObj;
                                            postObj.address_contact_id=0;
                                            this.setState({
                                                orderAddress:this.state.selectedObject
                                                ,postObj:postObj
                                                ,edited:true
                                            })
                                        }
                                    }
                                    >Process using Company Address</button>                                    
                                    <br />
                                    <table>
                                        <tr>
                                            <td className='plain'>
                                                {tae.getEditScreen(
                                                    this.state.columns
                                                    , this.state.selectedObject
                                                    , this.changeFieldValue.bind(this)
                                                    ) 
                                                } 

                                            </td>
                                            <td className='plain'>
                                            </td>
                                            <td className='plain'>
                                                <label>Address ({this.state.orderAddress.source} - {this.state.orderAddress.hubspot_company_id})</label><br/>
                                                {this.state.orderAddress.display_name}<br/>
                                                {this.state.orderAddress.display_contact_name}<br/>
                                                {this.state.orderAddress.display_phone}<br/>
                                                {this.state.orderAddress.display_email}<br/>
                                                {this.state.orderAddress.display_full_address}<br/>

                                            </td>
                                        </tr>
                                    </table>
                                    <br/>
                                    <div id="divContact">
                                    <TableScrollbar height={"40vh"}>
                                        <ErrorBoundary>

                                            <Table columns={[
                                                { key: 'display_name', title:"name", width :30 } 
                                                , { key: 'display_contact_name', title:"contact", width :5 }
                                                , { key: 'display_full_address', title:"address", width :5,render:tableColumnRender.renderMultiLineText }
                                                , { key: 'display_email', title:"email", width :30 } 
                                                , { key: 'display_phone', title:"phone", width :30 } 
                                                ,{key:'id',render:tableColumnRender.renderProcessOrder.bind(this)}
                                                ]} 
                                                
                                                dataSource={this.state.contacts} 
        /*                                        onRowClick={(rowData)=>{
                                                    this.state.postObj.address_contact_id=rowData.hubspot_contact_object_id;
                                                    this.setState({
                                                        orderAddress:rowData
                                                        ,postObj:this.state.postObj
                                                        ,edited:true
                                                    })
                                                }} 
        */
                                            ></Table>
                                        </ErrorBoundary>
                                    </TableScrollbar>       
                                    </div>                             
                                </div>             
                            </TabPanel>
                            <TabPanel >
                                <div style={{ height:"80vh" }}>
                                    <OrderDetailTable 
                                        securityObject={this.props.securityObject}
                                        orderId={this.state.selectedObject.id}
                                        sourceOrderId={this.state.selectedObject.source_order_id}
                                        orderType={this.props.orderType}
                                        orderAddress={this.state.orderAddress}
                                        facilityId={this.state.selectedObject.facility_id}
                                        facilityName={this.state.selectedObject.display_name}
                                    ></OrderDetailTable>     
                                </div>
                                
                            </TabPanel>
                        </Tabs>
                </Popup>   
                <FacilityPopup 
                    facilityId={this.state.selectedObject.facility_id}
                    //hubspot_company_id={()=>this.state.selectedObject.hubspot_company_id}
                    visible={this.state.facilityPopupVisible}
                    securityObject={this.props.securityObject}
                    onCloseFacilityPopup={()=>this.setState({facilityPopupVisible:false})}
                ></FacilityPopup>
            </div>
        ):"";
    }

    saveChanges(){
        db.saveData( this.props.securityObject
            , this.state.postObj
            ,"api/updateOrderHeader"
            , this.afterSave.bind(this)
        );  
    }

    afterSave(saveData){
        let id=this.state.selectedObject.id;
        if(id===-1){
            id=saveData.resultObject.insertId;
        }
        this.loadDeal(id);
    }
    loadDeal(id){
        db.getOrderHeader(this.props.securityObject,id,(data)=>{
            this.setState({
                selectedObject:data[0]
                ,orderAddress:data[0]
                ,postObj:{id:id, order_type:this.props.orderType,last_updated_by:this.props.securityObject.userName}
                ,edited:false
            })
            db.getHubspotContactsWithParent( data[0].hubspot_company_id
                        ,this.props.securityObject
                        ,(data2)=>{
                this.setState({
                    contacts:data2
                })
                data2.forEach(contact => {
                    if(contact.hubspot_contact_object_id===data[0].address_contact_id){
                        this.setState({
                            orderAddress:contact
                        })
                    }
                });
            }

            )
        })
    }
    afterClosePopup(){
    }
  
    showEditScreen(rowData){
        if(rowData.id===-1){
            rowData.order_type=this.props.orderType;
            this.setState({
                selectedObject:rowData,
                contacts:[]
            })            
        } else {
            this.loadDeal(rowData.id);
        }
        this.setState({
            postObj:{ id:rowData.id
                , order_type:this.props.orderType
                ,last_updated_by:this.props.securityObject.userName
                ,order_purpose:this.props.orderPurposeList[0].value
            }
            ,edited:false
        
        });
        if(document.getElementById("inputTableAddEdittype")){
            document.getElementById("inputTableAddEdittype").onchange=this.changeType.bind(this);
        }
        
        /*db.getOrderHeader(
            rowData.hubspot_object_id 
            ,this.props.securityObject
            , (header)=>{
                this.setState({
                    selectedObject:header
                })
        });
        */
    }
    // close the popup
    closePopup(){
        if(!this.state.edited || window.confirm("Are you sure you want to close without saving data?")){
            this.setState({
                selectedObject:false
            });
            this.queryData();
        }
    }    
    changeFieldValue(event) {
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj;
        postObj[key]=val;
        this.setState({
            edited:true,
            postObj:postObj
        })
    }  
    selectFacility(rowData){
        document.getElementById("inputTableAddEditfacility_id").value=rowData.id;
        document.getElementById("inputTableAddEditdisplay_name").value=rowData.display_name;
        let postObj=this.state.postObj;
        postObj.facility_id=rowData.id;
        this.setState({
            edited:true,
            postObj:postObj
        })  
        this.saveChanges();      
    }
    changeType(event){
        //this.updateNote();
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj;
        postObj[key]=val;
        this.setState({
            edited:true,
            postObj:postObj
        })
    }
    hideContacts(){
        document.getElementById("divContact").className="hidden";
    }
    showContacts(){
        document.getElementById("divContact").className="display";
    } 
    createFacilityHubSpotCompany(rowData){
        if(rowData.facility_id){
            alert("This facility already exists")
        } else {
            let thisApp=this;
            db.saveData( this.props.securityObject
                , {
                    hubspot_company_id:rowData.hubspot_object_id,
                    facility_name:rowData.facility_name,
                    facility_type:"commercial"
                }
                ,"api/updateFacility"
                , function(result){
                    if(result.resultCode==1){
                        //alert(JSON.stringify(result.resultObject.insertId));
                        let postObj=thisApp.state.postObj;
                        postObj.facility_id=result.resultObject.insertId;
                        thisApp.setState({
                            edited:true,
                            postObj:postObj
                        })  
                        thisApp.saveChanges(); 
                        //alert(JSON.stringify(result.resultObject.insertId)); 
                    } else {
                        alert(JSON.stringify(result));
                    }
                });
        }
    }   
}